import { useQuery } from '@tanstack/react-query'

import { api } from './api'

export function useHealthCheck() {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => api.checkHealth(),
    retry: 1,
    refetchInterval: 120000
  })
}
